import { createStyles, makeStyles } from '@material-ui/core/styles';

const useWorkspaceDialogStyles = makeStyles(() =>
  createStyles({
    dialogTitleContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '0.5rem 0.5rem 0 0'
    },
    dialogContainer: {
      padding: '0rem 4rem 4rem 4rem !important'
    },
    dialogLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '2rem'
    },
    dialogFormContainer: {
      display: 'grid',
      gap: '1rem',
      marginBottom: '1rem'
    }
  })
);

export default useWorkspaceDialogStyles;
